import WIP from "../components/WIP/WIP";

const About = () => {
  return (
    <div>
      <WIP />
    </div>
  );
};

export default About;
